import React from "react";
import cx from "classnames";
import { ToastContainer } from "brass-ui-kit";
import {
  AppDownloadModal,
  AuthActionModal,
  Footer,
  MigrationNoticeBanner,
  Navbar,
} from "../../design-system";
import { LayoutContext } from "../../../context";
import { DefaultMethodsType, DEFAULT_VALUES } from "../../../context/Layout";
import { useMigrationCountdown } from "../../../hooks/useMigrationCountdown";
import { useMigrationHeroInView } from "../../../hooks/useMigrationHeroInView";

import { Hero } from "components/blog";

import * as styles from "./PageLayout.module.scss";

interface PageLayoutProps {
  pageContext: {
    layout: "default" | "blog";
  };
  location: Location;
}

const isHomePath = (pathname: string) =>
  pathname === "/" || pathname === "/index.html";

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  pageContext,
  location,
}) => {
  const [state, setState] = React.useState(DEFAULT_VALUES);
  const isBlog = pageContext.layout === "blog";
  const isHomePage = isHomePath(location.pathname);
  const { isPast: migrationCountdownPast } = useMigrationCountdown();
  const migrationHeroInView = useMigrationHeroInView(
    isHomePage && !migrationCountdownPast
  );
  const showMigrationBanner =
    !migrationCountdownPast &&
    (!isHomePage || !migrationHeroInView);
  const offsetContentForBanner = showMigrationBanner && !isHomePage;

  const handleStateUpdate: DefaultMethodsType["updateContext"] = (newState) =>
    setState((state) => ({ ...state, ...newState }));

  return (
    <LayoutContext.Provider
      value={{ ...state, updateContext: handleStateUpdate }}
    >
      <main className={styles.PageLayout}>
        <header className={styles.PageLayout_header}>
          <Navbar location={location} />
          {showMigrationBanner && <MigrationNoticeBanner />}
        </header>
        <div
          className={cx(
            styles.PageLayout_content,
            offsetContentForBanner && styles.PageLayout_content_withBanner
          )}
        >
          {isBlog && <Hero />}
          {children}
        </div>
        <AppDownloadModal />
        <AuthActionModal />
        <Footer location={location} />
      </main>
      <ToastContainer />
    </LayoutContext.Provider>
  );
};

PageLayout.defaultProps = {
  pageContext: {
    layout: "default",
  },
};
export default PageLayout;
